import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=2d7096b6&scoped=true&"
import script from "./Room.vue?vue&type=script&lang=js&"
export * from "./Room.vue?vue&type=script&lang=js&"
import style0 from "./Room.vue?vue&type=style&index=0&id=2d7096b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7096b6",
  null
  
)

export default component.exports